module.exports = __webpack_public_path__ + "static/media/flats.d8833fcc.svg";